module.exports = __webpack_public_path__ + "img/flag-UK.e2d822fa.svg";